import { relations } from "drizzle-orm";
import { boolean, pgTable, serial, text, timestamp } from "drizzle-orm/pg-core";
import { article } from "./articles";
import { subscription } from "./subscriptions";

export const business = pgTable("business", {
  id: serial("id").primaryKey(),
  user_id: text("user_id").notNull(),
  businessName: text("business_name").notNull(),

  websiteUrl: text("website_url").notNull(),
  blogUrl: text("blog_url"),
  blogPostTitles: text("blog_post_titles").array(),
  businessDescription: text("business_description").notNull(),
  industry: text("industry").notNull(),
  products: text("products").array(),
  targetAudience: text("target_audience").notNull(),
  tone: text("tone").notNull(),
  keyFeatures: text("key_features").array(),
  pricing: text("pricing").notNull(),
  other: text("other"),
  imageStyle: text("image_style"),

  automaticPublishing: boolean("automatic_publishing").notNull().default(true),

  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const businessRelations = relations(business, ({ many, one }) => ({
  articles: many(article),
  subscription: one(subscription),
}));
